//src/app/services/tasks/index.ts
import api, {
  buildQueryParams,
  IGetQueryParams,
  IPaginatedRepsonse,
} from '../index';
import { IClientBusiness, EngagementLetter } from '../responseTypes';
import { IUser } from '../user';

interface IGetTasksResponse {
  tasks: ITask[];
}

export interface ITask {
  id: number;
  client?: IUser;
  clients?: IUser[];
  shared_with_client: boolean;
  title: string;
  description: string;
  due_date: null;
  department: null;
  job_type?: string;
  status: string;
  assignees: IUser[];
  businesses?: IClientBusiness[];
  assignee_ids?: number[];
  business_ids?: number[];
  notes: [];
  created_at: string;
  updated_at: string;
  tax_return_status: string;
  requires_engagement_letter?: boolean;
  service_price_cents?: number;
  service_id?: number;
  engagement_letter?: EngagementLetter;
}
export const devicesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getJobTypes: builder.query<string[], void>({
      query: () => '/job_types',
      transformResponse: (response: { job_types: string[] }) =>
        response.job_types,
    }),
    getTasks: builder.query<ITask[], void>({
      query: () => '/tasks',

      transformResponse: (response: IGetTasksResponse) => response.tasks,
    }),
    getPaginatedTasks: builder.query<
      IPaginatedRepsonse<ITask>,
      IGetQueryParams<{
        accountant_id?: number;
        client_id?: number;
        search?: string;
        tax_return_status?: string[];
      }>
    >({
      query: ({ filters = {}, ...params }) =>
        `/tasks/paginated_index${buildQueryParams(
          { filters, ...params },
          true,
        )}`,
      providesTags: [{ type: 'Tasks', id: 'List' }],
    }),

    getTaskById: builder.query({
      query: (id: string) => `/tasks/${id}`,

      transformResponse: (response: { task: ITask }) => response.task,
    }),
    getTasktByFilterId: builder.query<
      ITask[],
      {
        accountant_id?: number;
        client_id?: number;
        business_id?: number;
      }
    >({
      query: (filters) => {
        let params = [];
        if (filters.accountant_id) {
          params.push(`accountant_id=${filters.accountant_id}`);
        }
        if (filters.client_id) {
          params.push(`client_id=${filters.client_id}`);
        }
        if (filters.business_id) {
          params.push(`business_id=${filters.business_id}`);
        }
        return `/tasks?${params.join('&')}`;
      },

      transformResponse: (response: IGetTasksResponse) => response.tasks,
    }),
    createTask: builder.mutation<
      { task: ITask },
      {
        title: string;
        description: string;
        client_id?: number;
        assignee_ids: number[];
        business_ids?: number[];
        shared_with_client: boolean;
        // job_type: string;
      }
    >({
      query: (body) => {
        const task = {
          task: {
            title: body.title,
            description: body.description,
            client_id: body.client_id,
            assignee_ids: body.assignee_ids,
            business_ids: body.business_ids,
            shared_with_client: body.shared_with_client,
            // job_type: body.job_type,
          },
        };

        return {
          url: `/tasks`,
          method: 'POST',
          body: task,
        };
      },
    }),

    updateTask: builder.mutation<ITask, { task: Partial<ITask> }>({
      query: (body: { task: Partial<ITask> }) => {
        return {
          url: `/tasks/${body.task.id}`,
          method: 'PUT',
          body,
        };
      },

      transformResponse: (response: { task: ITask }) => response.task,
    }),
    deleteTaskById: builder.mutation<any, number>({
      query: (id: number) => ({
        url: `/tasks/${id}`,
        method: 'DELETE',
      }),
    }),
  }),
});

export const {
  useGetJobTypesQuery,
  useCreateTaskMutation,
  useGetTasksQuery,
  useGetTaskByIdQuery,
  useGetTasktByFilterIdQuery,
  useLazyGetTasktByFilterIdQuery,
  useUpdateTaskMutation,
  useDeleteTaskByIdMutation,
  useLazyGetTasksQuery,
  useLazyGetPaginatedTasksQuery,
} = devicesApi;
